import gql from "graphql-tag";

const imageFields = `id
  alternativeText
  url
  formats
`;

export const GET_STRUCTURE = gql`
  query GET_STRUCTURE($countryCode: String!) {
    redirects {
      source
      destination
      ignoreTrailingSlash
    }
    countries {
      id
      name
      twoLetterCode
      phoneNumberText
      phoneNumberLink
      variables {
        id
        name
        value
      }
      topBanner {
        id
        published
        backgroundColor
        text
        buttonText
        buttonLink
        textColor
        buttonTextColor
        buttonColor
      }
    }
    config {
      storeLinks {
        appStoreLink
        playStoreLink
      }
      mailchimpLinks {
        mailchimpAudienceUrl
        mailchimpNewsletterUrl
      }
    }
    heroes( where:{ twoLetterCode: $countryCode} ){
      id
      title
      twoLetterCode
      meta {
        id
        seo {
          id
          description
          index
          keywords
          thumbnail {
            ${imageFields}
          }
        }
      }
      content {
        __typename
        ... on ComponentPageHeroV4 {
          id
          published
          title
          description
          image{
            id
            desktop{
              ${imageFields}
            }
            mobile{
              ${imageFields}
            }
          }
          bottomText
          services {
            package
            startTime
            endTime
            timeInterval
            bufferTimeForBooking
            formType
            useBookingForm
            bookingFormReplacementMessage
          }
          bufferTimeForBooking
          formUrl
        }
        ...on ComponentPageHero {
          id
          published
          title
          mobileTitle
          description
          image{
            id
            desktop{
              ${imageFields}
            }
            mobile{
              ${imageFields}
            }
          }
          buttonIsScroll
          buttonIsExternal
          displayDownloadButtons
          link {
            id
            text
            path
          }
        }
      }
  	}
    navigations (
      where: { country: { twoLetterCode: $countryCode } }
    ) {
      id
      language
      phoneNumber
      logo {
        ${imageFields}
      }
      logoAlternative {
        ${imageFields}
      }
      navigationSection {
        id
        title
        level
        path
        isOneColumn
        elements {
          id
          text
          desc
          target
          descLong
          path
          comingSoon
          image {
            ${imageFields}
          }
        }
      }
    }
    footers (
      where: { country: { twoLetterCode: $countryCode } }
    ) {
      id
      language
      phoneNumber
      email
      footerSection {
        id
        title
        elements {
          id
          text
          link
          path
          desc
          order
          comingSoon
        }
      }
      address {
        id
        title
        entries {
          id
          text
        }
      }
      businessCertificationLogos {
        id
        media {
          ${imageFields}
        }
      }
    }
    mobileModal {
      id
      title
      stars
      button
      image {
        ${imageFields}
      }
    }
  }
`;
